import { EXPORT_FORMATS } from '@shared/config/exportConstants'
import { apiClient, ApiName } from '@shared/services/api'

export const fetchClients = (config) => {
  return apiClient.get(ApiName.ADMINS, 'clients', config)
}

export const exportClients = (config) => {
  return apiClient.get(
    ApiName.ADMINS,
    'clients/export',
    { format: EXPORT_FORMATS.CSV, ...config },
    { responseType: 'blob' }
  )
}

export const fetchClient = (id) => {
  return apiClient.get(ApiName.ADMINS, `clients/${id}`)
}

export const updateClient = (data) => {
  return apiClient.put(ApiName.ADMINS, 'clients', data)
}

export const deleteClient = (id) => {
  return apiClient.delete(ApiName.ADMINS, 'super/clients', id)
}

export const fetchClientOnboarding = (id) => {
  return apiClient.get(ApiName.ADMINS, `onboardings/clients/${id}`)
}

export const updateClientOnboarding = (id, data) => {
  return apiClient.patch(ApiName.ADMINS, `onboardings/clients/${id}`, data)
}

export const createUser = (data) => {
  return apiClient.post(ApiName.ADMINS, 'clients/users', data)
}

export const deleteUser = (id) => {
  return apiClient.delete(ApiName.ADMINS, 'super/users', id)
}

export const sendUserClientInvite = (id) => {
  return apiClient.post(ApiName.ADMINS, `clients/users/${id}/invites`)
}

export const uploadDocumentOnboarding = (clientId, formData) => {
  return apiClient.post(ApiName.ADMINS, `onboardings/clients/${clientId}/docs`, formData, {
    'Content-Type': 'multipart/form-data'
  })
}

export const createDocsSignature = (data, clientId) => {
  return apiClient.post(
    ApiName.ADMINS,
    `onboardings/clients/${clientId}/docs/docusign/registrationForm`,
    data
  )
}

export const createDocsKycBs2 = (data, clientId) => {
  return apiClient.post(
    ApiName.ADMINS,
    `onboardings/clients/${clientId}/docs/docusign/contracts/kyc`,
    data
  )
}

export const createNewBank = (data) => {
  return apiClient.post(ApiName.ADMINS, 'clients/exchangeRecipients', data)
}

export const editBank = (id, data) => {
  return apiClient.patch(ApiName.ADMINS, `clients/exchangeRecipients/${id}`, data)
}

export const registerPromocodeClient = (clientId, data) => {
  return apiClient.post(ApiName.ADMINS, `clients/${clientId}/promoCodes`, data)
}

export const expirePromocodeClient = (clientId, data) => {
  return apiClient.patch(ApiName.ADMINS, `clients/${clientId}/promoCodes/expire`, data)
}
